// extracted by mini-css-extract-plugin
export default {"form":"PlayTypeSelector_form__9u4cf"};